module.exports = __webpack_public_path__ + "static/media/speaker.a56e513f.svg";